import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-epbt-fa-new-quick-order-operations',
  templateUrl: './epbt-fa-new-quick-order-operations.component.html',
  styleUrls: ['./epbt-fa-new-quick-order-operations.component.scss']
})
export class EpbtFaNewQuickOrderOperationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
